/** `bd-` plus a random id: letters, digits and hyphens only, so it passes the API's key rule (1 to 100 characters of A-Za-z0-9._:-). */
export function newIdempotencyKey(): string {
  return `bd-${crypto.randomUUID()}`;
}
